<template>
    <div>
        <b-form-input
                v-b-modal="'modal-change-version-' + tag"
                :id="tag"
                :name="tag"
                type="text"
                v-model="value"
                :state="null"
                :placeholder="placeholder"
                @click="getGlobalVersions"
                @keypress="onKeyPress"
                @keyup.esc="onKeyEsc"
                @keyup.enter="onKeyEnter"
                @focus.native="onFocus"
                :disabled="false"
                size="sm"
                v-bind:class="{itempropertyupdated: isUpdated && ! notApplicable && ! committed, invalidinput: isInvalid}"
                :style="'min-width: ' + bestCellWidth(value, tag) + '; text-align: center;'">
                :ref="tag">
        </b-form-input>
        <b-modal :id="'modal-change-version-' + tag" title="Change Global Version" hide-backdrop @ok="onOk" @cancel="onCancel" @close="onReset" :return-focus="selectNextCell()">

            <h5 class="mt-3">ID: {{ localVersionId }}</h5>
            <h5 class="mt-3">Name: {{ versionName }}</h5>
            <h5 class="mt-3">Price: {{ price }}</h5>

            <hr>

            <h6 class="mt-3">Select new global version</h6>
            <template v-if="globalVersions.length">
                <div v-for="globalVersion in globalVersions" :key="globalVersion.id">
                    <div class="input-group-prepend">
                        <div class="input-group-text">
                            <b-form-radio v-model="selectedVersion" name="version" :value="globalVersion.id"></b-form-radio>
                        </div>
                        <div class="btn btn-outline-secondary btn-block dc7-btn-left" data-toggle="collapse" :data-target="'#collapse' + globalVersion.id" aria-expanded="false" aria-controls="collapseExample">
                            &nbsp;{{globalVersion.id}}&nbsp;-&nbsp;{{globalVersion.name}}
                            <span class="badge badge-primary badge-pill">{{globalVersion.local_versions_count}}</span>
                        </div>
                    </div>
                    <div class="collapse" :id="'collapse' + globalVersion.id">
                        <div class="card card-body dc7-btn-card">
                            <ul>
                                <li v-for="(localVersion, index) in globalVersion.localVersions" :key="index">{{localVersion.name}} ({{localVersion.countries}})</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>

            <div class="form-group pt-3">
                <label class="btn btn-outline-info dc7-btn-left">
                    <b-form-radio v-model="selectedVersion" name="create_new_version" value="new">
                        I am sure above lists have no suitable version; generate a new one
                    </b-form-radio>
                </label>
            </div>
            <!-- Footer -->
            <template v-slot:modal-footer="{ok, cancel, close}">
                <b-button size="sm" variant="danger" @click="close()">
                    Reset
                </b-button>
                <b-button size="sm" variant="secondary" @click="cancel()">
                    Cancel
                </b-button>
                <b-button size="sm"
                        variant="primary"
                        @click="ok()"
                        :disabled="createIsDisabled">
                    Change GID
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import cellTypeMixin from './CellTypeMixin.vue'
    import inputCellMixin from './InputCellMixin.vue'
    export default {
        mixins: [cellTypeMixin, inputCellMixin],
        props: {
            tag: {
                type: String,
                required: true
            },
            validation: {
                type: Object
            },
            brandId: {
                type: Number|String,
                required: true
            },
            countryId: {
                type: String,
                required: true
            },
            route: {
                type: String,
                required: true
            },
            storedData: {
                type: String|Number,
                default: null
            },
            placeholder: String,
            disabled: {
                type: Boolean,
                default: false
            },
            committed: {
                type: Boolean,
                default: false
            },
            gridItemIndex: {
                type: Number,
                required: true
            }
        },

        data () {
            return {
                globalVersions: [],
                selectedVersion: null,
                newVersionName: null,
            }
        },

        mounted () {
            if (this.value == 0) {
                this.selectedVersion = 'new';
            } else {
                this.selectedVersion = this.value
            }
        },

        computed: {
            createIsDisabled: function() {
                return this.selectedVersion == null && this.newVersionName == null;
            },
            localVersionId: function() {
                if (this.getGridItem().local_versions__id.original.startsWith('new_')) {
                    return '_' + this.getGridItem().local_versions__id.original.replace('new_', '').padStart(5, 0);
                }

                return this.getGridItem().local_versions__id.original;
            },
            versionName: function() {
                if (this.getGridItem().local_versions__name.is_updated) {
                    return this.getGridItem().local_versions__name.updated;
                } else {
                    return this.getGridItem().local_versions__name.original;
                }
            },
            price: function() {
                if (this.getGridItem().prices__price_incl_tax.is_updated) {
                    return this.getGridItem().prices__price_incl_tax.updated;
                } else {
                    return this.getGridItem().prices__price_incl_tax.original;
                }
            },
        },

        methods: {
            getGlobalVersions: function(event) {
                axios.get('/api/change-versions/get-global-versions/' + this.getGridItem().local_versions__id.original)
                    .then(response => {
                        this.globalVersions = response.data;
                    });
            },
            onKeyPress: function(event) {
                event.preventDefault();
            },
            onKeyEsc: function (event) {
                this.isInvalid = false;
                this.isUpdated = false;
                this.storedData.is_updated = false;
                this.storedData.updated = "";
                this.value = this.storedData.original;
                this.selectedVersion = this.value;
                this.newVersionName = null;
                this.onChange(this.value);
            },
            onKeyEnter: function (event) {
                this.focusNextCell();
            },
            onReset: function () {
                this.onKeyEsc();
            },
            onOk: function () {
                if (this.selectedVersion == 'new') {
                    this.value = '000000';
                } else {
                    this.value = this.selectedVersion;
                }

                this.onChange(this.value);
                this.$nextTick(() => {
                    this.focusNextCell();
                });
            },
            onCancel: function () {
                this.selectedVersion = null;
                this.globalVersions = [];
                this.newVersionName = null;
                this.$nextTick(() => {
                    this.focusNextCell();
                });
            }
        },
    }
</script>
